import React from 'react'

import LoginForm from '../components/forms/LoginForm'
import gordonLogo from '../images/gordon_logo.svg'

import { Logo, Main } from '../styles/pages/LoginPageStyle'
import { setViewportWidth } from '../useViewPort'

const LoginPage = () => {
  setTimeout(() => setViewportWidth())

  return (
    <Main>
      <Logo src={gordonLogo} alt="Logo" />
      <LoginForm />
    </Main>
  )
}

export default LoginPage
